<div id="profile-container" class="container">
    <h1>
        <i class="fa fa-id-card-o" aria-hidden="true"></i>
        {{ 'profile.title' | translate }}
    </h1>

    <div class="picture row">
        <div class="col-md-12">
            <h2>{{ 'profile.picture.title' | translate }}</h2>
            <div class="wrapper">
                <div class="picture-actions">
                    <label
                        class="btn btn-default"
                        style="margin-bottom: 4px; margin-right: 10px"
                    >
                        {{ 'profile.picture.change-default' | translate }}
                        <input
                            (change)="pictureFileChange($event)"
                            type="file"
                            style="display: none;"
                            accept="image/*"
                        />
                    </label>
                    {{ pictureFileError }}
                    <br />
                    <button class="btn btn-default" (click)="resetPicture()">
                        {{ 'profile.picture.reset-default' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="bio row">
        <div class="col-md-12">
            <h2>{{ 'profile.bio.title' | translate }}</h2>
            <textarea
                #name="ngModel"
                class="form-control"
                [placeholder]="'profile.bio.placeholder' | translate"
                [(ngModel)]="profile.bio"
            >
            </textarea>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="actions">
                <button
                    class="btn btn-default"
                    [disabled]="!isBioFormValid()"
                    (click)="saveBio()"
                >
                    {{ 'profile.save' | translate }}
                </button>
            </div>

            <div *ngIf="success" class="alert alert-success">
                <strong>{{ 'profile.save-success' | translate }}</strong>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/profile/profile.component.html